import { CardInfo } from "./card-info.model";

export class CardLink {
   /*
   *
   */
    constructor(
      public id?:  number,
      public displaySorting?: number,
      public recommended?: boolean,
      public link?: string, 
      public photo?: string,
      public cardInfo?: CardInfo  
    ){}
    
}